var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 167,
    height: 211,
    viewBox: "0 0 167 211",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.94825e-06 144.368C8.02886 145.955 16.7268 148.599 26.0938 152.301C35.7284 156.267 44.8277 161.423 53.3918 167.769C61.9559 174.379 68.6466 182.311 73.4639 191.566L75.0697 191.566L72.6611 -4.12369e-06L94.339 -3.17612e-06L91.9303 191.566L93.5361 191.566C99.6915 181.783 106.917 173.718 115.214 167.372C123.51 161.026 132.208 156.003 141.308 152.301C150.407 148.863 158.971 146.219 167 144.368L167 167.769C157.365 169.091 147.998 171.471 138.899 174.908C130.067 178.61 121.637 183.369 113.608 189.186C105.579 195.268 98.0857 202.539 91.1274 211L75.8726 211C65.4351 198.837 54.3285 189.054 42.5529 181.65C30.7773 174.511 16.593 169.884 7.92538e-06 167.769L8.94825e-06 144.368Z",
    fill: "#7B46FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.39d39d6adaedbebd05affa1250cf32bb.svg";
export { ForwardRef as ReactComponent };